/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./ButtonDelete.vue?vue&type=template&id=37fffe4a"
import script from "./ButtonDelete.ts?vue&type=script&lang=ts&external"
export * from "./ButtonDelete.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports